import { createContext } from 'react';

export type TranslationType = {
	code: string;
	description: string | null;
	langCode: string;
	name: string | null;
};

export const LevelContext = createContext<{
	userLanguage: string;
	setUserLanguage: (lang: string) => void;
	translations: TranslationType[];
	setTranslations: (translations: TranslationType[]) => void;
	devMode: boolean;
	setDevMode: (arg: boolean) => void;
	emailForPasswordReset: string;
	setEmailForPasswordReset: (email: string) => void;
}>({
	userLanguage: localStorage.getItem('userLanguage') ?? 'IT',
	setUserLanguage: (lang: string) => {},
	translations: [],
	setTranslations: () => {},
	devMode: localStorage.getItem('devMode') === 'true',
	setDevMode: () => {},
	setEmailForPasswordReset: (email: string) => {
		if (email === '') {
			localStorage.removeItem('emailForPasswordReset');
		} else {
			localStorage.setItem('emailForPasswordReset', email);
		}
	},
	emailForPasswordReset: localStorage.getItem('emailForPasswordReset') ?? '',
});
